/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyManat = createReactComponent("outline", "currency-manat", "IconCurrencyManat", [["path", { "d": "M7 19v-7a5 5 0 1 1 10 0v7", "key": "svg-0" }], ["path", { "d": "M12 5v14", "key": "svg-1" }]]);

export { IconCurrencyManat as default };
//# sourceMappingURL=IconCurrencyManat.mjs.map
